import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { Product } from 'app/products/domain/product';
import { ICompany } from 'app/shared/Domains/company';
import { IDeliveryContact } from 'app/shared/Domains/deliveryContact';
import { IDeliveryAddress } from 'app/shared/Domains/deliveryAddress';
import { IUser } from 'app/shared/Domains/IUser';
import { IRole } from 'app/shared/Domains/role';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import { IProduct } from './domain/IProduct';
import { SaleOrder } from './domain/SaleOrder';
import { IBranch } from 'app/shared/Domains/branch';
import { IMember } from 'app/shared/Domains/member';
import { SoldTo } from 'app/shared/Domains/soldTo';
import { Ingredients } from './domain/Ingredients';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-point-of-sale',
  templateUrl: './point-of-sale.component.html',
  host: { "(window:keyup)": "hotkeys($event)", "(window:click)": "hotClick($event)" },
  styleUrls: ['./point-of-sale.component.css']
})
export class PointOfSaleComponent implements OnInit {
  @ViewChild("rowQuantity", { static: false }) rowQuantityInput: ElementRef;
  @ViewChild("searchProduct", { static: false }) searchProductInput: ElementRef;
  @ViewChild("searchMember", { static: false }) searchMemberInput: ElementRef;
  @ViewChild("op") gridViewData: OverlayPanel;
  productsInPanel: any[];
  Products: any[];
  selectedProducts: any[];
  loading: boolean;
  user: IUser;
  sourceProducts: any[];
  first: number = 0;
  product: Product;
  selectProduct: Product;
  vatTax: number;
  orderProduct: IProduct[];
  newSaleOrder: SaleOrder;
  isDisableSalesOrder: boolean = false;
  // isDeliveryEnabled: boolean = false;
  towardsCheckOut: boolean = false;
  company: ICompany;
  role: IRole;
  saleOrderId: string;
  mode: string;
  enterSteps: any[];
  currentStep: any;
  index: number = 0;
  summarySteps: any[];
  summaryStepsWithDelivery: any[];
  summaryCurrentStep: any;
  rowIndex: number = -1;
  keyBuffer: any[] = [];
  deliveryStatusButtonString: string;
  branch: IBranch;
  members: IMember[];
  selectedMember: any;
  membersInPanel: any[];
  memberName: any;
  showExtraIngredients: boolean;
  ingredients: Ingredients[] = [];
  defaultIngredients: any[] = [];
  extraIngredientsDialogVisibility: boolean;
  paymentOptions: any;
  totalIngredients: Ingredients[] = [];
  areIngredientsEnough = true;
  areIngredientsEnoughArray: boolean[] = [];
  minValue: number;
  individualMax: any;
  paymentMode: any;

  constructor(
    private LanguageService: LanguageService,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    public config: Configuration,
    private route: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
  ) {
    route.params.subscribe((params) => {
      this.saleOrderId = params["id"];
      if (this.saleOrderId !== null && this.saleOrderId !== undefined) {
        this.getSaleOrderById();
        // this.mode = 'edit';

      } else {
        this.mode = 'add';
      }
      this.breadcrumbService.setItems([
        { label: "Sales", routerLink: ["/sale-orders"] },
        { label: "Sale-Order" },
      ]);
    });
  }
	setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("PointOfSaleComponent", label);
  }
  ngOnInit() {
    this.InitObjects();
    this.user = AuthService.getLoggedInUser();
    this.role = AuthService.getLoggedInRole();
    this.getCompany();
    this.getMembers();
    this.showExtraIngredients = false;
    this.productsInPanel = [];
    this.membersInPanel = [];
    this.Products = [];
    this.selectedProducts = [];
    this.getProducts();
    this.product = new Product();
    this.selectProduct = new Product();
    this.company = new ICompany();
    this.vatTax = 5;
    this.orderProduct = [];
    this.newSaleOrder.discount = 0;
    this.newSaleOrder.isDeliveryEnabled = false;
    this.sum();
    this.paymentOptions = [
      { label: 'Cash - Reception', value: 'Cash-Reception' },
    ];
    this.getBranch();
    this.paymentMode = "Cash-Reception";
    this.currentStep = 0;
    this.summaryCurrentStep = 0;
    this.summarySteps = [
      "overallDiscount",
      "paymentReceived",
      "checkoutButton"
    ];
    this.summaryStepsWithDelivery = [
      "overallDiscount",
      "deliveryFirstName",
      "deliveryLastName",
      "deliveryEmail",
      "deliveryPhone",
      "deliveryAddress",
      "deliveryCity",
      "deliveryState",
      "deliveryZIPCode",
      "paymentReceived",
      "checkoutDeliveryButton"
    ];
  }

  InitObjects() {
    this.newSaleOrder = new SaleOrder();
    this.newSaleOrder.deliveryContactDetails = new IDeliveryContact();
    this.newSaleOrder.deliveryContactDetails.deliveryAddress = new IDeliveryAddress();
    this.newSaleOrder.soldTo = new SoldTo();
    this.newSaleOrder.modeOfPayment = "Cash-Reception";
    this.memberName = "Walk in Customer";
  }

  initializeIngredientsEnoughArray(): void {
    this.areIngredientsEnoughArray = Array.from({ length: this.ingredients.length }, () => true);
  }

  getMembers() {
    this.members = [];
    this.loading = true;
    this.appServiceManager.get('customers/company/' + this.user.company + '/branch/' + this.user.branch + '/short').subscribe((res: IMember[]) => {
      if (res.length > 0) {
        this.members = res;
        this.membersInPanel = res;
        this.loading = false;
      } else {
        this.loading = false;
        this.members = [];
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
    },
      (error) => {
        // this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error.error.message, });
      });
  }

  getSaleOrderById() {
    this.loading = true;
    this.appServiceManager.get("products/getSaleOrder/" + this.saleOrderId).subscribe(
      data => {
        this.newSaleOrder = data;
        this.mode = 'edit';
        this.orderProduct = this.newSaleOrder.products;
        if (this.newSaleOrder.status == 'POS') {
          this.memberName = this.newSaleOrder.soldTo.name;
          this.newSaleOrder.isDeliveryEnabled = false;
          this.newSaleOrder.deliveryContactDetails = new IDeliveryContact();
          this.newSaleOrder.deliveryContactDetails.deliveryAddress = new IDeliveryAddress();

        } else {
          this.newSaleOrder.isDeliveryEnabled = true;
          if (this.newSaleOrder.status == 'REQUESTED') {
            this.deliveryStatusButtonString = "Confirm Order";
          } else if (this.newSaleOrder.status == 'CONFIRMED') {
            this.deliveryStatusButtonString = "Confirm Ready to Shipped";
          } else if (this.newSaleOrder.status == 'READY_TO_SHIPPED') {
            this.deliveryStatusButtonString = "Confirm Shipped";
          } else if (this.newSaleOrder.status == 'SHIPPED') {
            this.deliveryStatusButtonString = "Confirm Delivered";
          } else if (this.newSaleOrder.status == 'DELIVERED') {
            this.deliveryStatusButtonString = "Delivered";
          }
        }
        this.loading = false;
        // let suppliers = [];
        // suppliers.push(this.newPurchaseOrder.supplier);
        // this.selectedSupplier = suppliers;
        // this.orderProduct = this.newPurchaseOrder.products;
        // if (this.newPurchaseOrder.status != undefined && this.newPurchaseOrder.status == 'FULFILLED') {
        //   this.isFulFil = true;
        //   this.fulFilButtonName = "FulFilled";

        // } else {
        //   this.isFulFil = false;
        //   this.fulFilButtonName = "FulFil";

        // }
      },
      error => {
        this.loading = false;
        alert(error);
      }
    );
  }

  getCompany() {
    this.company = AuthService.getLoggedInCompanyBranch();
    if(!this.company){
    this.appServiceManager.get("companies/" + this.user.company).subscribe(
      (res) => {
        if (res) {
          this.company = res;
        } else {
          this.company = new ICompany();
          this.messageService.clear();
          this.messageService.add({
            severity: "info",
            summary: "Info Message",
            detail: "Something Went Wrong",
          });
        }
      },
      (error) => {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({
          severity: "error",
          summary: "Error Message",
          detail: error,
        });
      }
    );
  }
}
  getBranch() {
    this.branch = AuthService.getLoggedInCurrentBranch();
    if(this.branch){
      if (Array.isArray(this.branch.payments)) {
        this.branch.payments.forEach(payment => {
          const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
          if (!existingBank) {
            this.paymentOptions.push({
              label: `${payment.type} - ${payment.name}`,
              value: `${payment.type}-${payment.name}`
            });
          }
        });
    }
  }
  if(!this.branch){
  this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
      if (res) {
        this.branch = res;
        res.payments.forEach(payment => {
          const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
          if (!existingBank) {
            this.paymentOptions.push({
              label: `${payment.type} - ${payment.name}`,
              value: `${payment.type}-${payment.name}`
            });
          }
        });
      } else {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
    }
  }

  getProducts() {
    this.loading = true;
    this.appServiceManager.get(`products/company/${this.user.company}/branch/${this.user.branch}`).subscribe((res: any) => {
      if (res.length > 0) {
        this.productsInPanel = res;
        this.sourceProducts = res;
        this.Products = res;
        this.defaultIngredients = res
          .filter(x => x.type === "Ingredients")
          .map(x => ({ code: x.code, totalQuantity: x.totalQuantity }));
        console.log('default', this.defaultIngredients);

      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  onPaymentModeChange(value: string) {
    this.paymentMode = value;
    this.newSaleOrder.modeOfPayment = this.paymentMode;
  }

  resetSoldTo() {
    this.memberName = "Walk in Customer";
    this.newSaleOrder.soldTo = new SoldTo();
    this.selectedMember = undefined;
  }

  searchPanelProducts(event, value, type) {
    if (!(event.keyCode == 40 || event.keyCode == 38)) {
      let matchedName = [];
      if (value !== null && value !== undefined && value.toString().length > 0) {
        if (value == "") {
          this.productsInPanel = Object.assign([], this.sourceProducts);
        }
        if (!value) {
          this.productsInPanel = Object.assign([], this.sourceProducts);
        }
        if (value != "") {

          if (type === "name") {
            matchedName = Object.assign([], this.sourceProducts).filter(
              cust => (cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null) || (cust.barcode ? cust.barcode.indexOf(value) > -1 : null));
          }

          const distinct = (value, index, self) => {
            return self.indexOf(value) === index;
          }
          const source = matchedName;
          this.productsInPanel = source.filter(distinct);

          // let panal: any = document.getElementById("op");
          // let data = this.productsInPanel[0];
          // this.onProductRowSelect({data}, panal)

          if (this.productsInPanel.length === 0) {
            this.productsInPanel = [];
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
          } else {
            this.first = 0;
            this.rowIndex = -1;
            if (this.productsInPanel.length === 1) {
              this.first = 0;
              this.rowIndex = -1;
            }
            this.productsInPanel = [...this.productsInPanel];
          }
        }
      } else {
        this.productsInPanel = Object.assign([], this.sourceProducts);
        this.productsInPanel = [...this.productsInPanel];
      }
    }

  }
  searchPanelMember(event, value, type) {
    if (!(event.keyCode == 40 || event.keyCode == 38)) {
      let matchedName = [];
      if (value !== null && value !== undefined && value.toString().length > 0) {
        if (value == "") {
          this.membersInPanel = Object.assign([], this.members);
        }
        if (!value) {
          this.membersInPanel = Object.assign([], this.members);
        }
        if (value != "") {

          if (type === "name") {
            matchedName = Object.assign([], this.members).filter(
              cust => (cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null) || (cust.tagNumber ? cust.tagNumber.indexOf(value) > -1 : null));
          }

          const distinct = (value, index, self) => {
            return self.indexOf(value) === index;
          }
          const source = matchedName;
          this.membersInPanel = source.filter(distinct);

          // let panal: any = document.getElementById("op");
          // let data = this.membersInPanel[0];
          // this.onProductRowSelect({data}, panal)

          if (this.membersInPanel.length === 0) {
            this.membersInPanel = [];
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
          } else {
            this.first = 0;
            this.rowIndex = -1;
            if (this.membersInPanel.length === 1) {
              this.first = 0;
              this.rowIndex = -1;
            }
            this.membersInPanel = [...this.membersInPanel];
          }
        }
      } else {
        this.membersInPanel = Object.assign([], this.members);
        this.membersInPanel = [...this.membersInPanel];
      }
    }

  }

  onPageChange(event) {
    this.first = event.first;
  }

  onProductRowSelect(event, productsPanel: OverlayPanel) {
    this.getProducts();
    const check = this.orderProduct.filter(x => x.code === event.data.code);
    if (check.length > 0 && event.data.type != "Ingredients Based") {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Product Already Added' });
    } else {
      if (event.data.totalQuantity == 0 && event.data.type != "Ingredients Based") {
        return;
      }
      if (event.data.type == "Ingredients Based") {
        this.addIngredients(event.data.ingredients);
        if (!this.checkIngredientsEnough(this.totalIngredients)) {
          this.messageService.clear();
          this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Ingredients for this product are not enough.' });
          this.areIngredientsEnough = false;
          return;
        }
        else {
          this.extraIngredientsDialogVisibility = true;
          this.ingredients = [...event.data.ingredients];
        }
      }
      this.initializeIngredientsEnoughArray();
      const productToBeSale = new IProduct();
      productToBeSale._id = event.data._id;
      productToBeSale.productId = event.data._id;
      productToBeSale.name = event.data.name;
      productToBeSale.code = event.data.code;
      productToBeSale.type = event.data.type;
      productToBeSale.quantity = 1;
      productToBeSale.totalQuantity = event.data.totalQuantity;
      productToBeSale.unitPrice = event.data.normalPrice ? event.data.normalPrice : 1;
      productToBeSale.subTotal = productToBeSale.quantity * productToBeSale.unitPrice;
      productToBeSale.discount = 0;
      productToBeSale.cost = event.data.cost;
      productToBeSale.gstOnProduct = event.data.gstOnProduct;
      productToBeSale.vatTax = Math.round(productToBeSale.subTotal * (event.data.gstOnProduct / 100));
      if (event.data.type == "Ingredients Based") {
        this.getMaximumQuantity(this.totalIngredients);
      }
      const products = [...this.orderProduct];
      products.push(productToBeSale);
      this.orderProduct = products;
      productsPanel.hide();
      this.sum();
      this.index = this.orderProduct.length - 1;
      this.enterSteps = [
        "rowQuantity-" + this.index,
        "rowUnitPrice-" + this.index,
        "rowDiscount-" + this.index,
      ];
      setTimeout(() => {
        document.getElementById(this.enterSteps[0]).focus()
        this.currentStep = 0;

      }, 500);
    }
  }
  addIngredients(ingredients) {
    if (this.totalIngredients.length == 0) {
      this.totalIngredients = ingredients.map(({ code, name, quantity }) => ({ code, name, quantity }));
      return;
    } else {
      for (const ingredient of ingredients) {
        const existingIngredient = this.totalIngredients.find(x => x.code === ingredient.code);

        if (existingIngredient) {
          // Update the quantity if the ingredient already exists
          existingIngredient.quantity += ingredient.quantity;
        } else {
          // Add the ingredient if it doesn't exist in totalIngredients
          this.totalIngredients.push({ ...ingredient });
        }
      }
    }
  }
  addSingleIngredient(code, baseQuantity) {
    const existingIngredient = this.totalIngredients.find(i => i.code === code);
    if (existingIngredient) {
      existingIngredient.quantity += baseQuantity; // Update totalQuantity
    }

  }
  subtractSingleIngredient(code, baseQuantity) {
    const existingIngredient = this.totalIngredients.find(i => i.code === code);
    if (existingIngredient) {
      existingIngredient.quantity = existingIngredient.quantity - baseQuantity; // Update totalQuantity
    }

  }

  checkIngredientsEnough(ingredients) {
    let returnValue = true;
    ingredients.map(ingredient => {
      const orgIng = this.sourceProducts.filter(i => i.code == ingredient.code)[0];
      if (orgIng != null) {
        if (orgIng.totalQuantity < ingredient.quantity) {
          returnValue = false;
          return;
        }
      }
    });
    return returnValue;
  }
  checkSingleIngredientsEnough(ingredient) {
    let returnValue = true;
    const orgIng = this.sourceProducts.filter(i => i.code == ingredient.code)[0];
    this.individualMax = orgIng.totalQuantity;
    if (orgIng != null) {
      if (orgIng.totalQuantity < ingredient.quantity) {
        returnValue = false;
        return;
      }
    }
    return returnValue;
  }
  onMemberRowSelect(event, productsPanel: OverlayPanel) {
    this.selectedMember = event.data;
    this.memberName = event.data.name;
    productsPanel.hide();
  }


  increaseQuantity(ingredient, index) {
    let existingIngredient;
    let check;
    if (this.totalIngredients.length != 0) {
      existingIngredient = this.totalIngredients.find(i => i.code === ingredient.code);
      check = this.checkSingleIngredientsEnough(existingIngredient);
    } else {
      check = this.checkSingleIngredientsEnough(ingredient);
    }
    let basePrice = 0;
    if (check) {
      if (ingredient.quantity < this.individualMax) {
        this.addSingleIngredient(ingredient.code, ingredient.baseQuantity);
        ingredient.quantity = ingredient.quantity + ingredient.baseQuantity;
        this.newSaleOrder.remainingSubtotal += ingredient.basePrice;
        if (this.orderProduct.length >= 1) {
          basePrice = this.orderProduct[this.index].unitPrice;
        }
        this.newSaleOrder.subTotal += ingredient.basePrice;
        basePrice += ingredient.basePrice;
        this.orderProduct[this.index].subTotal = basePrice;
        this.orderProduct[this.index].unitPrice = basePrice;
        this.newSaleOrder.total = Math.round(this.newSaleOrder.remainingSubtotal + this.newSaleOrder.vatTax);

      }
    } else {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Ingredients for this product are not enough.' });
      this.areIngredientsEnoughArray[index] = false;
      return;
    }
  }

  decreaseQuantity(ingredient, index) {
    if (this.areIngredientsEnoughArray[index] == false) {
      ingredient.quantity = ingredient.quantity - ingredient.baseQuantity;
    }
    this.subtractSingleIngredient(ingredient.code, ingredient.baseQuantity);
    if (this.areIngredientsEnoughArray[index] == true) {
      ingredient.quantity = ingredient.quantity - ingredient.baseQuantity;
      this.newSaleOrder.remainingSubtotal = this.newSaleOrder.remainingSubtotal - ingredient.basePrice;
      this.newSaleOrder.subTotal = this.newSaleOrder.subTotal - ingredient.basePrice;
      this.orderProduct[this.index].subTotal = this.orderProduct[this.index].subTotal - ingredient.basePrice;
      this.orderProduct[this.index].unitPrice = this.orderProduct[this.index].unitPrice - ingredient.basePrice;
      this.newSaleOrder.total = this.newSaleOrder.total - ingredient.basePrice;
    }
    this.areIngredientsEnoughArray[index] = true;

  }
  removeSelectedProduct(product) {
    this.getProducts();
    this.totalIngredients = [];
    this.ingredients = [];
    const products = [...this.orderProduct];
    const index = this.orderProduct.indexOf(product);
    if (index > -1) {
      products.splice(index, 1);
      this.sum();
      this.calculateBalance(this.newSaleOrder.paid)
      this.orderProduct = products;
      this.sum();
      this.index = this.orderProduct.length - 1;
      this.enterSteps = [
        "rowQuantity-" + this.index,
        "rowUnitPrice-" + this.index,
        "rowDiscount-" + this.index,
      ];

      setTimeout(() => {
        if (this.orderProduct.length > 0) {
          document.getElementById(this.enterSteps[0]).focus()
          this.currentStep = 0;
        }
      }, 300);
    }
    if (this.orderProduct.length == 0) {
      this.suspendSale();
    }
  }
  priceQuantityAndDiscountEvent(product, type) {
    let num = 0;
    if (type === "quantity" || type === "price" || type === "discount") {
      num = product.unitPrice * product.quantity;
      product.vatTax = Math.round(num * (product.gstOnProduct / 100));
      num = num - product.discount;
      product.subTotal = Math.round(num);
      const index = this.orderProduct.indexOf(product);
      this.orderProduct[index] = product;
      this.sum();
    }
  }

  sum() {
    this.newSaleOrder.subTotal = 0;
    this.newSaleOrder.total = 0;
    this.newSaleOrder.returned = 0;
    this.newSaleOrder.vatTax = 0;
    this.newSaleOrder.remainingSubtotal = 0;

    this.orderProduct.forEach(product => {
      this.newSaleOrder.subTotal = this.newSaleOrder.subTotal + product.subTotal;
      this.newSaleOrder.subTotal = Math.round(this.newSaleOrder.subTotal);
      this.newSaleOrder.vatTax = Math.round(this.newSaleOrder.vatTax + product.vatTax);
    });
    this.newSaleOrder.remainingSubtotal = Math.round(this.newSaleOrder.subTotal - (this.newSaleOrder.discount ? this.newSaleOrder.discount : 0));
    this.newSaleOrder.total = Math.round(this.newSaleOrder.remainingSubtotal + this.newSaleOrder.vatTax);

    if (isNaN(this.newSaleOrder.paid)) {
      this.newSaleOrder.paid = 0;
      this.newSaleOrder.returned = this.newSaleOrder.total;
      this.newSaleOrder.returned = Math.round(this.newSaleOrder.returned)
    }
    else {
      this.newSaleOrder.returned = this.newSaleOrder.paid - this.newSaleOrder.total;
      this.newSaleOrder.returned = Math.round(this.newSaleOrder.returned);
    }
  }

  getMaximumQuantity(productIngredients) {
    const quantityArray = [];

    this.sourceProducts.forEach((sourceProduct) => {
      const correspondingIngredient = productIngredients.find((ingredient) => ingredient.code === sourceProduct.code);

      if (correspondingIngredient) {
        quantityArray.push(sourceProduct.totalQuantity / correspondingIngredient.quantity);
      }
    });

    if (quantityArray.length > 0) {
      console.log(quantityArray);
      this.minValue = Math.min(...quantityArray);
    } else {
      // Handle the case where there are no matching elements
      this.minValue = undefined; // or any other value that makes sense in your context
    }
  }


  onOverallDiscountChange() {
    this.newSaleOrder.remainingSubtotal = 0;
    this.newSaleOrder.total = 0;
    this.newSaleOrder.discount = this.newSaleOrder.discount ? this.newSaleOrder.discount : 0;
    this.newSaleOrder.subTotal = this.newSaleOrder.subTotal ? this.newSaleOrder.subTotal : 0;
    // if (this.isPercentage) {
    //   this.newSaleOrder.remainingSubtotal = this.newSaleOrder.subTotal - (this.newSaleOrder.subTotal * this.newSaleOrder.discount / 100);
    // } else {
    this.newSaleOrder.remainingSubtotal = this.newSaleOrder.subTotal - this.newSaleOrder.discount;
    // }
    this.newSaleOrder.remainingSubtotal = Math.round(this.newSaleOrder.remainingSubtotal);
    this.newSaleOrder.total = Math.round(this.newSaleOrder.remainingSubtotal + this.newSaleOrder.vatTax);
    this.calculateBalance(this.newSaleOrder.paid);

  }

  calculateBalance(Amount) {
    this.newSaleOrder.returned = Amount - this.newSaleOrder.total;
    this.newSaleOrder.returned = Math.round(this.newSaleOrder.returned);
  }

  suspendSale() {
    this.isDisableSalesOrder = false;
    this.newSaleOrder = new SaleOrder();
    this.newSaleOrder.subTotal = 0;
    this.newSaleOrder.total = 0;
    this.newSaleOrder.discount = 0;
    this.newSaleOrder.paid = 0;
    this.newSaleOrder.returned = 0;
    this.newSaleOrder.vatTax = 0;
    this.newSaleOrder.remainingSubtotal = 0;
    this.orderProduct = [];
    this.newSaleOrder.deliveryContactDetails = new IDeliveryContact();
    this.newSaleOrder.deliveryContactDetails.deliveryAddress = new IDeliveryAddress();
  }

  ProductQuantityChange(v, p) {
    let quantityCheck = true;
    if (p.type == "Ingredients Based") {
      const upgradedIngredients = this.ingredients.map((ingredient) => {
        return {
          ...ingredient,
          quantity: v < p.quantity ? ingredient.quantity / p.quantity * v : ingredient.quantity * v
        };
      });
      this.totalIngredients = upgradedIngredients;
      quantityCheck = this.checkIngredientsEnough(upgradedIngredients);
    }
    // p.quantity = p.quantity -1;

    if (v < 1) {
      p.quantity = 1;
    }
    if (v > p.totalQuantity) {
      p.quantity = p.totalQuantity;
    }
    p.quantity = v;
    this.priceQuantityAndDiscountEvent(p, "quantity");
    if (!quantityCheck) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Ingredients for this product are finished.' });
    }
  }

  checkOut() {
    this.confirmationService.confirm({
      message: "Are you sure you want to proceed ?",
      accept: () => {
        const user = JSON.parse(localStorage.getItem("currentUser"));
        this.newSaleOrder.company = user.company;
        this.newSaleOrder.branch = user.branch;
        this.newSaleOrder.createdBy = this.user.name;
        this.newSaleOrder.productsTotalPurchasePrice = 0;

        if (this.selectedMember) {
          this.newSaleOrder.soldTo.name = this.selectedMember.name;
          this.newSaleOrder.soldTo.tagNumber = this.selectedMember.tagNumber;
          this.newSaleOrder.soldTo._id = this.selectedMember._id;
        }
        else {

          this.newSaleOrder.soldTo.name = this.memberName;
        }
        this.newSaleOrder.status = "POS"
        this.orderProduct.forEach((product) => {
          product.discount = parseInt(product.discount.toString());
          if (product.type != "Ingredients Based") {
            product.totalQuantity = product.totalQuantity - product.soldQuantity;
          }
          product.lastSoldPrice = product.unitPrice;
          product.SaleOrderProductLastQuantity = product.quantity;
          product.isSaleOrderQuantityChange = false;
          product.isNewItemInSaleOrder = true;
          this.newSaleOrder.productsTotalPurchasePrice += (product.cost * product.quantity);
        });
        this.newSaleOrder.products = this.orderProduct;
        this.appServiceManager.post("products/salesOrder", this.newSaleOrder).subscribe((res: any) => {
          if (res) {
            this.newSaleOrder = res.saleorder;
            this.getProducts()
            setTimeout(() => {
              this.printSaleInvoice();
              document.getElementById("suspendButton").focus();
            }, 300);
            this.isDisableSalesOrder = true;
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'CheckOut Successfully' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      },
      reject: () => {
        console.log("reject");
      }
    });
  }

  closeExtraIngredientsDialog() {
    this.extraIngredientsDialogVisibility = false;
    this.getMaximumQuantity(this.totalIngredients);
    this.orderProduct[this.index].ingredients = this.ingredients;
  }

  checkOutWithDeliveryOptions() {
    this.confirmationService.confirm({
      message: "Are you sure you want to proceed ?",
      accept: () => {
        const user = JSON.parse(localStorage.getItem("currentUser"));
        this.newSaleOrder.company = user.company;
        this.newSaleOrder.branch = user.branch;
        this.newSaleOrder.createdBy = this.user.name;
        this.newSaleOrder.productsTotalPurchasePrice = 0;
        this.orderProduct.forEach((product) => {
          product.discount = parseInt(product.discount.toString());
          product.totalQuantity = product.totalQuantity - product.soldQuantity;
          product.lastSoldPrice = product.unitPrice;
          product.SaleOrderProductLastQuantity = product.quantity;
          product.isSaleOrderQuantityChange = false;
          product.isNewItemInSaleOrder = true;
          this.newSaleOrder.productsTotalPurchasePrice += (product.cost * product.quantity);
        });

        this.newSaleOrder.products = this.orderProduct;
        this.appServiceManager.post("products/salesOrderWithDeliveryOptions", this.newSaleOrder).subscribe((res: any) => {
          if (res) {
            this.newSaleOrder = res.saleorder;
            this.getProducts()
            setTimeout(() => {
              this.printSaleInvoice();
              document.getElementById("suspendButton").focus();
            }, 300);
            this.isDisableSalesOrder = true;
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'CheckOut Successfully' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      },
      reject: () => {
        console.log("reject");
      }
    });
  }

  printSaleInvoice(): void {
    let printContents, popupWin;
    printContents = document.getElementById("salesInvoice").innerHTML;
    popupWin = window.open(
      "",
      "_blank",
      "top=0,left=0,height=100%,width=auto"
    );
    popupWin.document.open();
    popupWin.document.write(`
      <html>
      <head>
        <title>Gym Invoice</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
      </head>
      <body>${printContents}</body>
      </html>
    `);
  }

  addProductThroughBarcodeScanner(barcode) {
    this.keyBuffer = [];
    let barcodeMatchedProductObject = this.Products.find(x => x.barcode == barcode);
    let check = this.orderProduct.filter(x => x.code === barcodeMatchedProductObject.code);
    if (check.length > 0) {
      this.orderProduct[this.orderProduct.indexOf(check[0])].quantity = this.orderProduct[this.orderProduct.indexOf(check[0])].quantity + 1;
      this.orderProduct[this.orderProduct.indexOf(check[0])].subTotal = this.orderProduct[this.orderProduct.indexOf(check[0])].quantity * this.orderProduct[this.orderProduct.indexOf(check[0])].unitPrice;
      this.orderProduct[this.orderProduct.indexOf(check[0])].discount = 0;
      this.orderProduct[this.orderProduct.indexOf(check[0])].vatTax = Math.round(this.orderProduct[this.orderProduct.indexOf(check[0])].subTotal * (this.orderProduct[this.orderProduct.indexOf(check[0])].gstOnProduct / 100));
      this.sum();

    } else {
      let productToBeSale = new IProduct();
      productToBeSale._id = barcodeMatchedProductObject._id;
      productToBeSale.productId = barcodeMatchedProductObject._id;
      productToBeSale.name = barcodeMatchedProductObject.name;
      productToBeSale.code = barcodeMatchedProductObject.code;
      productToBeSale.quantity = 1;
      productToBeSale.totalQuantity = barcodeMatchedProductObject.totalQuantity;
      productToBeSale.unitPrice = barcodeMatchedProductObject.normalPrice ? barcodeMatchedProductObject.normalPrice : 1;
      productToBeSale.subTotal = productToBeSale.quantity * productToBeSale.unitPrice;
      productToBeSale.discount = 0;
      productToBeSale.vatTax = Math.round(productToBeSale.subTotal * (barcodeMatchedProductObject.gstOnProduct / 100));
      let products = [...this.orderProduct];
      products.push(productToBeSale);
      this.orderProduct = products;
      this.sum();
      this.index = this.orderProduct.length - 1;
      this.enterSteps = [
        "rowQuantity-" + this.index,
        "rowUnitPrice-" + this.index,
        "rowDiscount-" + this.index,
      ];

    }

  }

  disableAlphaNum(e) {
    var charCode = (e.which) ? e.which : e.keyCode;
    if (charCode >= 48 && charCode <= 57) {
      e.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  detectDiscountEvent(event, product) {
    if (event.currentTarget.value <= 0) {
      event.currentTarget.value = 0;
      product.discount = 0;
      this.priceQuantityAndDiscountEvent(product, 'discount');
    } else if (event.currentTarget.value >= product.unitPrice) {
      event.currentTarget.value = 0;
      product.discount = 0;
      this.priceQuantityAndDiscountEvent(product, 'discount');

    }
  }

  hotkeys($event) {

    if ($event.keyCode == 39 || $event.keyCode == 37) {
      const confirmationBox = document.getElementsByTagName("p-confirmdialog")[0];
      const confirmationBoxButtonExist = confirmationBox.getElementsByTagName("button");
      const confirmationBoxButtonExistLength = confirmationBox.getElementsByTagName("button").length;
      if (confirmationBoxButtonExistLength > 0) {
        if (document.activeElement.tagName === "BODY") {
          confirmationBoxButtonExist[0].focus();
        }
        else {
          if (document.activeElement === confirmationBoxButtonExist[0]) {
            confirmationBoxButtonExist[1].focus();
          }
          else if (document.activeElement === confirmationBoxButtonExist[1]) {
            confirmationBoxButtonExist[0].focus();
          }
          else {
            confirmationBoxButtonExist[0].focus();
          }
        }
      }
    }

    else if (!$event.ctrlKey && $event.keyCode == 13 && $event.code == 'NumpadEnter' && this.towardsCheckOut) {
      let nextStep = 0;
      let nextId = "";
      if (this.newSaleOrder.isDeliveryEnabled) {
        nextStep = this.summaryStepsWithDelivery.length - 1 > this.summaryCurrentStep ? this.summaryCurrentStep + 1 : 0;
        nextId = this.summaryStepsWithDelivery[nextStep];
      }
      else {
        nextStep = this.summarySteps.length - 1 > this.summaryCurrentStep ? this.summaryCurrentStep + 1 : 0;
        nextId = this.summarySteps[nextStep];
      }
      const ele: any = document.getElementById(nextId)
      if (nextId == "checkoutButton" && !(ele.disabled)) {
        ele.click();
        this.summaryCurrentStep = 0;
      } else if (nextId == "checkoutButton" && ele.disabled) {
        document.getElementById("overallDiscount").focus();
        this.summaryCurrentStep = 0;
      } else {
        ele.focus();
        this.summaryCurrentStep = nextStep;
      }
    }

    else if (!$event.ctrlKey && $event.keyCode == 13 && $event.code == 'NumpadEnter' && !this.towardsCheckOut) {
      var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
      var nextId = this.enterSteps[nextStep];
      let ele: any = document.getElementById(nextId)
      ele.focus();
      this.currentStep = nextStep;
    }

    else if ($event.ctrlKey && $event.keyCode == 13 && $event.code == 'NumpadEnter' && !($event.target.tagName == 'BODY')) {
      let ele: any = document.getElementById("overallDiscount");
      ele.focus();
      this.towardsCheckOut = true;
    }

    else if ($event.keyCode == 115) {
      this.searchProductInput.nativeElement.focus();
      this.searchProductInput.nativeElement.click();

    }
    else if ($event.keyCode == 113) {
      this.searchMemberInput.nativeElement.focus();
      this.searchMemberInput.nativeElement.click();

    }

    else if ($event.keyCode == 119 && this.mode == 'add') {
      this.newSaleOrder.isDeliveryEnabled = !this.newSaleOrder.isDeliveryEnabled;
      if (this.newSaleOrder.isDeliveryEnabled) {
        document.getElementById("deliveryFirstName").focus();
        this.summaryCurrentStep = 0;
      } else {
        document.getElementById("overallDiscount").focus();
        this.currentStep = 0;
      }
    }

    else if ($event.keyCode == 40) {
      if (this.gridViewData.overlayVisible == true) {
        this.rowIndex++;
        //move to next page
        if (this.rowIndex > this.productsInPanel.length - 1) {
          // if (this.rowIndex + 1 > ((pageIndex - 1) * this.dataTable.rows) + 10) {
          //     this.setCurrentPage(pageIndex + 1);
          // }
        }
        if (this.productsInPanel != undefined)
          this.selectProduct = this.productsInPanel[this.rowIndex];
      }
    }

    else if ($event.keyCode == 38) {
      this.rowIndex--;
      this.rowIndex = this.rowIndex < 0 ? 0 : this.rowIndex;
      //move back to previous page
      // if (this.rowIndex < ((pageIndex - 1) * this.dataTable.rows)) {
      //     this.setCurrentPage(pageIndex - 1);
      // }
      if (this.productsInPanel != undefined) {

        this.selectProduct = this.productsInPanel[this.rowIndex];
      }
    }

    else if ($event.keyCode == 13 && this.gridViewData.overlayVisible) {
      if (this.selectProduct) {
        var tempEvent: any = {};
        tempEvent.data = JSON.parse(JSON.stringify(this.selectProduct));
        this.onProductRowSelect(tempEvent, this.gridViewData)
        this.selectProduct = undefined;
        this.rowIndex = -1;
        // this.setCurrentPage(1);
      } else {
        this.rowIndex = 0;
        if (this.productsInPanel != undefined) {
          this.selectProduct = this.productsInPanel[0];
        }
      }
    }

    else if ($event.which === 13 && $event.target.tagName == 'BODY') {
      let barcode = this.keyBuffer.join("")
      console.log("BarCode Completed:", barcode);

      if (barcode.length > 0) {
        this.addProductThroughBarcodeScanner(barcode);
        this.keyBuffer = [];
      }
    }

    var number = $event.which - 48;
    if (number < 0 || number > 9) {
      return;
    }
    this.keyBuffer.push(number);
  }

  hotClick($event) {
    let currentClickLocation = $event.target.id;
    let isSummaryStepsWithDelivery = this.summaryStepsWithDelivery.filter(x => x === currentClickLocation).length > 0;
    let isSummarySteps = this.summarySteps.filter(x => x === currentClickLocation).length > 0;
    let isEnterSteps = this.enterSteps && this.enterSteps.filter(x => x === currentClickLocation).length > 0;
    if (isSummaryStepsWithDelivery) {
      let indexOfClickField = this.summaryStepsWithDelivery.indexOf(currentClickLocation);
      if (indexOfClickField !== -1) {
        this.summaryCurrentStep = indexOfClickField;
      } else {
        this.summaryCurrentStep = this.summaryCurrentStep;
      }
      this.towardsCheckOut = true;
    }
    if (isSummarySteps && !isSummaryStepsWithDelivery) {
      let indexOfClickField = this.summarySteps.indexOf(currentClickLocation);
      if (indexOfClickField !== -1) {
        this.summaryCurrentStep = indexOfClickField;
      } else {
        this.summaryCurrentStep = this.summaryCurrentStep;
      }
      this.towardsCheckOut = true;
    }
    if (isEnterSteps && this.orderProduct.length > 0) {
      let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
      if (indexOfClickField !== -1) {
        this.currentStep = indexOfClickField;
      } else {
        this.currentStep = this.currentStep;
      }
      this.towardsCheckOut = false;
      this.summaryCurrentStep = 0;
    }
  }

  handleSwitchChange(e) {
    if (e.checked) {
      document.getElementById("deliveryFirstName").focus();
      this.summaryCurrentStep = 0;
    } else {
      document.getElementById("overallDiscount").focus();
      this.summaryCurrentStep = 0;
    }
  }

  changeDeliveryStatus() {
    this.confirmationService.confirm({
      message: "Are you sure you want to change status ?",
      accept: () => {
        let data = {
          status: this.newSaleOrder.status == 'REQUESTED' ? 'CONFIRMED'
            : this.newSaleOrder.status == 'CONFIRMED' ? 'READY_TO_SHIPPED'
              : this.newSaleOrder.status == 'READY_TO_SHIPPED' ? 'SHIPPED'
                : 'DELIVERED',
          modifiedBy: this.user._id
        }
        this.appServiceManager
          .put("products/changeDeliveryStatus/" + this.saleOrderId, data)
          .subscribe(
            (res: any) => {
              if (res) {
                this.newSaleOrder = res.saleOrder;
                this.getSaleOrderById();
                this.messageService.add({
                  severity: "success",
                  summary: "Success Message",
                  detail: "Status Successfully Updated",
                });
              } else {
                this.messageService.clear();
                this.messageService.add({
                  severity: "info",
                  summary: "Info Message",
                  detail: "Something Went Wrong",
                });
              }
            },
            (error) => {
              this.messageService.clear();
              this.messageService.add({
                severity: "error",
                summary: "Error Message",
                detail: error,
              });
            }
          );
      },
    });
  }

  PriceQuantityChange(v, p) {
    p.unitPrice = v;
    this.priceQuantityAndDiscountEvent(p, "price");
  }

  DiscountQuantityChange(v, p) {
    p.discount = v;
    this.priceQuantityAndDiscountEvent(p, "discount");
  }
}
